function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M508.696,115.588L396.689,3.581c-4.404-4.403-11.544-4.403-15.949,0L311.171,73.15l-30.798-30.798 c-4.404-4.403-11.544-4.403-15.949,0L58.352,248.426c-28.067,28.068-28.067,73.737,0,101.803l0.794,0.794l-26.49,26.489 c-4.404,4.404-4.404,11.544,0,15.949l35.106,35.106l-31.289,31.288c-4.404,4.404-4.404,11.544,0,15.949 c2.202,2.201,5.088,3.303,7.974,3.303c2.886,0,5.773-1.102,7.974-3.303l31.289-31.289l35.106,35.106 c2.114,2.114,4.983,3.303,7.974,3.303c2.991,0,5.86-1.189,7.974-3.303l26.489-26.49l0.794,0.794 c13.597,13.597,31.673,21.084,50.902,21.084c19.228,0,37.306-7.488,50.902-21.084l206.073-206.073 c4.405-4.404,4.405-11.544,0-15.949l-30.797-30.798l69.57-69.569C513.101,127.132,513.101,119.992,508.696,115.588z M126.789,455.699l-70.212-70.212l18.515-18.515l70.212,70.211L126.789,455.699z M446.002,239.878L247.903,437.977 c-9.336,9.336-21.75,14.479-34.954,14.479s-25.617-5.142-34.954-14.479L74.3,334.281c-19.274-19.274-19.274-50.632,0-69.906 L272.399,66.276L446.002,239.878z M423.178,185.158l-96.059-96.059l61.595-61.595l96.059,96.059L423.178,185.158z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.178,143.456c2.886,0,5.773-1.102,7.974-3.303l8.616-8.617c4.404-4.405,4.404-11.544,0-15.949 c-4.404-4.403-11.544-4.403-15.948,0l-8.616,8.617c-4.404,4.405-4.404,11.544,0,15.949 C417.406,142.355,420.292,143.456,423.178,143.456z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.125,81.125c-4.404,4.404-4.405,11.543,0,15.949c2.202,2.201,5.088,3.303,7.974,3.303 c2.886,0,5.772-1.102,7.974-3.303l8.616-8.616c4.404-4.404,4.405-11.543,0-15.949c-4.403-4.401-11.543-4.403-15.948,0 L372.125,81.125z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.662,219.404l39.256-39.256c4.404-4.404,4.405-11.544,0-15.949c-4.404-4.401-11.544-4.403-15.948,0l-43.726,43.725 c-2.776,2.778-3.91,6.798-2.99,10.616l15.249,63.284l-23.852,23.853c-14.63-7.786-33.244-5.527-45.557,6.785 c-15.085,15.087-15.085,39.635,0,54.72c7.308,7.308,17.025,11.332,27.361,11.332s20.052-4.024,27.361-11.332 c12.312-12.312,14.571-30.927,6.785-45.556l47.764-47.763l63.284,15.248c0.875,0.212,1.761,0.314,2.641,0.314 c2.956,0,5.834-1.163,7.974-3.303l43.726-43.726c4.404-4.404,4.404-11.544,0-15.949c-4.404-4.403-11.544-4.403-15.948,0 l-39.256,39.257l-43.726-10.536l63.893-63.892c4.404-4.404,4.404-11.544,0-15.949c-4.404-4.401-11.543-4.403-15.949,0 l-87.805,87.804L222.662,219.404z M183.865,351.234c-3.048,3.048-7.101,4.726-11.411,4.726c-4.311,0-8.364-1.678-11.411-4.726 c-6.293-6.293-6.293-16.53,0-22.823c3.147-3.146,7.279-4.719,11.413-4.719c4.132,0,8.266,1.573,11.411,4.719 C190.158,334.703,190.158,344.943,183.865,351.234z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.808,490.964l-1.503,1.503c-4.405,4.403-4.406,11.543-0.002,15.948c2.202,2.204,5.088,3.305,7.975,3.305 c2.886,0,5.771-1.101,7.973-3.302l1.503-1.503c4.405-4.403,4.406-11.543,0.002-15.948 C16.352,486.561,9.211,486.559,4.808,490.964z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcp);
export default __webpack_public_path__ + "static/media/ecp.9e167aad2465bf4b3c2ded1f336f4132.svg";
export { ForwardRef as ReactComponent };